// extracted by css-extract-rspack-plugin
export default {"serarchFrom":"serarchFrom___mKUEP","input_contain":"input_contain___8bdWC","btn_contain":"btn_contain___TmIMR"};